import { useQuery } from '@tanstack/react-query';

import { usersApi } from '../lib/users-api';

export const TENANT_MEMBERS_QUERY_KEY = ['tenant-members'] as const;

export function useTenantMembers() {
  const query = useQuery({
    queryKey: TENANT_MEMBERS_QUERY_KEY,
    queryFn: usersApi.getTenantMembers,
  });

  return {
    members: query.data ?? [],
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
